let last_id = 0

export default {
  namespaced: true,

  state: {
    alerts: []
  },

  mutations: {
    push(state, alert) {
      state.alerts.push(alert)
    },

    remove(state, { id }) {
      state.alerts = state.alerts.filter(alert => {
        return alert.id !== id
      })
    }
  },

  actions: {
    add(context, { trans, type, duration = 7000, dismissible = true }) {
      let id = ++last_id

      if (typeof trans === 'string') {
        trans = {
          text: trans,
          data: {}
        }
      }

      context.commit('push', {
        id,
        trans,
        type,
        dismissible
      })

      if (typeof duration === 'number') {
        setTimeout(() => context.commit('remove', { id }), duration)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Alerts.js